import { render } from "./NewServicesParameters.vue?vue&type=template&id=504aa5f8"
import script from "./NewServicesParameters.vue?vue&type=script&lang=ts"
export * from "./NewServicesParameters.vue?vue&type=script&lang=ts"

import "./NewServicesParameters.vue?vue&type=style&index=0&id=504aa5f8&lang=scss"
script.render = render

export default script